<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Container, Select, Text, Alert } from '@Shelly/shelly-design-system';
	import { SystemScreenBreakpoints } from '@Shelly/shelly-design-system/helpers/enums';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';

	export let editableObject;
	const deviceActions = editableObject;
	const options = ['1', '3', '5', '10'];

	let value = deviceActions?.blindTime || '1';
	let windowClientWidth: number;

	const handleBlindTimeSelect = (e) => {
		value = e.detail;
		deviceActions.blindTime = value; //dispatching blind time on selection so will be updated with value on next button
	};

	$: isMobile = windowClientWidth < SystemScreenBreakpoints.MOBILE_MAX;
</script>

<svelte:window bind:innerWidth={windowClientWidth} />

<Container padding="scrollPaddings">
	<Alert
		class={classMap({
			'mb-l': !isMobile,
			'mb-m': isMobile,
		})}
		heading={$format('motion_blind_time_description', {
			values: { min: 1, max: 10 },
		})}
	/>

	<Text class="mb-m" styleType="h2">
		{$format('select_blind_time', {
			default: 'Select blind time',
		})}
	</Text>
	<Select
		icon="fas fa-clock"
		class="pb-s"
		{options}
		label={$format('select_blind_placeholder', {
			default: 'Please select blind time',
		})}
		{value}
		on:change={handleBlindTimeSelect}
		id="select-4xa5jtx"
		aria-labelledby="select-4xa5jtx"
	/>
</Container>
